module.exports = __webpack_public_path__ + "img/icon-news.d03ab78a.svg";